import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Profil from '@/views/Profil.vue'
import Tupoksi from '@/views/Tupoksi.vue'
import Visi from '@/views/Visi.vue'
import Struktur from '@/views/Struktur.vue'
import Pejabat from '@/views/Pejabat.vue'
import Sekretariat from '@/views/Sekretariat.vue'
import Ikp from '@/views/Ikp.vue'
import Tik from '@/views/tik.vue'
import Persandian from '@/views/Persandian.vue'
import DataCenter from '@/views/DataCenter.vue'
import Berita from '@/views/Berita.vue'
import DetailBerita from '@/views/DetailBerita.vue'
import Infografis from '@/views/Infografis.vue'
import Peraturan from '@/views/Peraturan.vue'
import Dokumen from '@/views/Dokumen.vue'
import Sop from '@/views/Sop.vue'
import Foto from '@/views/Foto.vue'
import Video from '@/views/Video.vue'
import Dpa from '@/views/Dpa.vue'
import Lakip from '@/views/Lakip.vue'
import Kinerja from '@/views/Kinerja.vue'
import Lppd from '@/views/Lppd.vue'
import Pmprb from '@/views/Pmprb.vue'
import Renstra from '@/views/Renstra.vue'
import Rka from '@/views/Rka.vue'
import Renja from '@/views/Renja.vue'
import Spbe from '@/views/Spbe.vue'
import Kontak from '@/views/Kontak.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil
  },
  {
    path: '/tupoksi',
    name: 'tupoksi',
    component: Tupoksi
  },
  {
    path: '/visi',
    name: 'visi',
    component: Visi
  },
  {
    path: '/struktur',
    name: 'struktur',
    component: Struktur
  },
  {
    path: '/pejabat',
    name: 'pejabat',
    component: Pejabat
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: Sekretariat
  },
  {
    path: '/ikp',
    name: 'ikp',
    component: Ikp
  },
  {
    path: '/tik',
    name: 'tik',
    component: Tik
  },
  {
    path: '/persandian',
    name: 'persandian',
    component: Persandian
  },
  {
    path: '/datacenter',
    name: 'datacenter',
    component: DataCenter
  },
  {
    path: '/berita',
    name: 'berita',
    component: Berita
  },
  {
    path: '/detail_berita',
    name: 'detail_berita',
    component: DetailBerita
  },
  {
    path: '/infografis',
    name: 'infografis',
    component: Infografis
  },
  {
    path: '/peraturan',
    name: 'peraturan',
    component: Peraturan
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: Dokumen
  },
  {
    path: '/sop',
    name: 'sop',
    component: Sop
  },
  {
    path: '/foto',
    name: 'foto',
    component: Foto
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },
  {
    path: '/dpa',
    name: 'dpa',
    component: Dpa
  },
  {
    path: '/lakip',
    name: 'lakip',
    component: Lakip
  },
  {
    path: '/lppd',
    name: 'lppd',
    component: Lppd
  },
  {
    path: '/kinerja',
    name: 'kinerja',
    component: Kinerja
  },
  {
    path: '/pmprb',
    name: 'pmprb',
    component: Pmprb
  },
  {
    path: '/renstra',
    name: 'renstra',
    component: Renstra
  },
  {
    path: '/rka',
    name: 'rka',
    component: Rka
  },
  {
    path: '/renja',
    name: 'renja',
    component: Renja
  },
  {
    path: '/spbe',
    name: 'spbe',
    component: Spbe
  },
  {
    path: '/kontak',
    name: 'kontak',
    component: Kontak
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
